<template>
  <div class="content">
    <SystemPageList :systemPageList="systemPageList" :systemPageListTitle="langJson[lang].allProducts || ''" :itemSubtitleNeeded="true" />
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '~/stores/main';

  definePageMeta({ middleware: 'check-token' });

  const store = useMainStore();
  const langJson = computed(() => store.langJson);
  const lang = computed(() => store.lang);
  const categories = computed(() => store.categories);
  const systemPageList = computed(() => {
    return categories.value
      .filter((item) => item.productBlockType === 'ProductSection')
      .map((item) => ({
        nodeId: item.nodeId,
        id: item.id,
        external: typeof item.external === 'object' ? item.external : {},
        internal: {},
        title: item.title,
        nodes:
          item.nodes?.map((node) => ({
            id: node.id,
            nodeId: node.nodeId,
            external: typeof node.external === 'object' ? node.external : {},
            internal: {},
            title: node.title,
            resources: node.resources || []
          })) || []
      }));
  });
</script>
